import { render, staticRenderFns } from "./DlgPressEdit.vue?vue&type=template&id=2bbed16f&scoped=true&"
import script from "./DlgPressEdit.vue?vue&type=script&lang=ts&"
export * from "./DlgPressEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbed16f",
  null
  
)

export default component.exports